import React, { useEffect, useState, useRef,useContext } from 'react';
import { ContenedorParametros } from "../components/utils/ContenedorParametros";
import { ContenedorTabla } from '../components/utils/ContenedorTabla';
import { Modal } from '../components/modal/Modal';
import { UserContext } from '../../context/provider/UserProvider';
import { BotonNuevo } from '../components/buttons/BotonNuevo';
import { useModal } from '../../hooks/useModal';
import { notify, primeraLetraMayuscula, soloNumero } from '../../utils/utils';
import { useRecargas } from '../../hooks/useRecargas';
import { useOperaciones } from '../../hooks/useOperaciones';
import { Tooltip } from '../components/utils/Tooltip';
import { DatePickerDoble } from '../components/pickers/DatePickerDoble';

export const Operaciones =()=>{

    const { stateUser, signOut } = useContext(UserContext)
    const [ startDate, setStartDate ] = useState(new Date())
    const [ endDate, setEndDate ] = useState(new Date())
    const {         
        listarOperaciones,
        verificarInicioOperacion,
        operaciones,
        operacion,
        iniciarOperacion,
        finalizarOperacion,
        operacionActiva,
        resumenMontoOperaciones,
        isOpenModalResumenMonto ,
        closeModalResumenMonto,
        listarResumenMontos,
        isOpenModalIncioOperacion,
        openModalInicioOperacion,
        closeModalInicioOperacion
    } = useOperaciones()
    const { bancos } = useRecargas();
    const [ operacionFinalizar, setOperacionFinalizar ] = useState();

    const registrarOperacion = () => {

        const montosPorEntidad = bancos.map(banco => ({
            codEntidadBancariaCuenta: banco.codEntidadBancariaCuenta,
            monto: 0
        }));
        const operacion = {
            uid: stateUser.uid,
            listaDetallaMovimiento: montosPorEntidad.map(item => ({
                monto: item.monto,
                codEntidadBancariaCuenta: item.codEntidadBancariaCuenta
            }))
        };
        iniciarOperacion(operacion)
    };

    const [totalBancos, setTotalBancos ] = useState(0)


    useEffect(()=>{
        listarOperaciones(startDate, endDate)
    },[startDate, endDate])

return(
    <>
        <ContenedorParametros titulo="Operaciones">
            <DatePickerDoble
                startDate={startDate}
                setStartDate={setStartDate}
                endDate={endDate}
                setEndDate={setEndDate}
            />
            <BotonNuevo onClick={()=>openModalInicioOperacion()}>Nuevo</BotonNuevo>
        </ContenedorParametros>
        <ContenedorTabla>
                <div className='containerScroll  mt-7 relative top-0 bottom-0 left-0 right-0 contenedor-tabla'>
                    <table className="table ">
                        <thead>
                            <tr>
                                {/* <th className="text-center">N</th> */}
                                <th className="text-center">CODIGO</th>
                                <th className="text-center">FECHA HORA INICIO </th>
                                <th className='text-center'>FECHA HORA FIN</th>
                                <th className="text-center">USUARIO</th>
                                <th className="text-center"></th>
                                <th className="text-center"></th>
                            </tr>
                        </thead>
                        <tbody>
                        {
                            operaciones?.length > 0
                            ? operaciones?.map((operacion, i) => {
                                return (
                                    <tr key={operacion.codUsuarioOperacion}>
                                        {/* <td className='text-center'>{ ++i}</td> */}
                                        <td className="text-center">{operacion.codUsuarioOperacion}</td>
                                        <td className="text-center">{operacion.fechaHoraInicio}</td>
                                        <td className="text-center">{operacion.fechaHoraFin}</td>
                                        <td className="text-center">{operacion.uidRegistro}</td>
                                        <td className={`text-center ` }>
                                            <span className={`${operacion.nomEstado =="CERRADO"? 'bg-red-800':'bg-green-700' } p-1 rounded`}>
                                                {primeraLetraMayuscula(operacion.nomEstado)}
                                            </span>
                                        </td>
                                        <td 
                                            className="text-center"
                                            onClick={()=>{setOperacionFinalizar(operacion);listarResumenMontos(operacion.codUsuarioOperacion)}}
                                        >

                                            <i  
                                                data-tip 
                                                data-for={operacion.nomEstado === "CERRADO"? 'toolVerAcumulado':'toolCierreOperacion'}  
                                                className={` text-xl ${operacion.nomEstado === "CERRADO"? 'text-gray-500' :'text-yellow-500' } hover:text-green-300 fa fa-money-bill ` }
                                            ></i>
                                        </td>
                                        <Tooltip id={'toolCierreOperacion'}>
                                            {`Finalizar operación`}
                                        </Tooltip>
                                        <Tooltip id={'toolVerAcumulado'}>
                                            {`Ver acumulado`}
                                        </Tooltip>
                                    </tr>
                                )
                            })
                            : <tr><td colSpan="9" className="text-center">No hay información que mostrar con los parámetros seleccionados.</td></tr>
                        }
                        </tbody>
                    </table>
                </div>

        </ContenedorTabla>

        <Modal
            isOpen={isOpenModalIncioOperacion}
            closeModal={closeModalInicioOperacion}
            action={registrarOperacion}
            title="Iniciar Operaciones"
            spinner={{}}
            textButtons={{ confirm: 'Iniciar Operaciones', denied: 'Cerrar' }}
            validButton={{ confirm: true, denied: true }}
        >
            <div className="flex gap-8 items-center flex-wrap justify-center">
                <div className="w-[350px] flex flex-col px-4">
                    <span className='text-center'>Ingrese PIN se seguridad</span>
                    <input 
                        type='password'
                        className='text-center text-white h-[50px] rounded caret-white px-2 w-full bg-zinc-900 text-3xl focus:outline-none focus:ring-1 focus:ring-blue-500'
                    />
                    <div className='border-t border-gray-500 containerScroll  mt-2 relative top-0 bottom-0 left-0 right-0 contenedor-tabla'>
                        <span>Lista de bancos</span>
                            {
                                bancos?.length > 0
                                    ? bancos?.map((banco, index) => (
                                        <div className='flex text-xs p-2'>
                                            <a 
                                                href={banco.urlPaginaOficialEntidadBancaria}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                <img className='w-[60px] h-[60px] ' src={banco.urlLogoEntidadBancaria} alt=''/>
                                            </a>
                                            <div className='flex-col p-1  flex'>
                                                <span>{banco.nomEntidadBancaria}</span>
                                                <span>CTA: {banco.cuentaBancaria}</span>
                                                <span>CCI: {banco.cci}</span>
                                            </div>
                                        </div>                                
                                    ))
                                    :
                                        <div>
                                            <span>No se encontraron bancos registrados</span>
                                        </div>
                            }


                            
                    

                    </div>
                </div>
            </div>

        </Modal> 

        <Modal 
            isOpen={isOpenModalResumenMonto} 
            closeModal={closeModalResumenMonto} 
            action={()=>finalizarOperacion(operacionFinalizar.codUsuarioOperacion)}
            // title= {`Finalizar Operaciones [ ${operacionFinalizar?.codUsuarioOperacion} - ${operacionFinalizar?.nomUsuario}]`}
            title= {`Finalizar Operaciones - [ ${operacionFinalizar?.codUsuarioOperacion} ]`}
            spinner={{}}
            textButtons={{ confirm: 'Finalizar Operaciones', denied: 'Cancelar' }}
            validButton ={{confirm: operacionFinalizar?.nomEstado === "CERRADO"? false :true, denied: true}} 

        >
            <div className="text-center flex items-center flex-wrap justify-center">      
                <div className="w-[400px] px-2">
                    <div className=' text-center text-xl text-blue-300 mb-5'>
                        <i className='fa fa-user'/> {operacionFinalizar?.nomUsuario}
                    </div>

                <div className="flex gap-8 items-center flex-wrap justify-center">
                    
                <div className="w-[400px] flex flex-col px-4">
                    <span className='text-xl'>Resumen de montos recaudado</span>
                    <div className='containerScroll  mt-3 relative   top-0 bottom-0 left-0 right-0 contenedor-tabla'>
                        
                        {
                            resumenMontoOperaciones?.length > 0
                                ? resumenMontoOperaciones?.map((rmo, index) => (
                                    <div className='flex justify-between text-xl mt-2 border-b border-gray-600 '>
                                        {/* <a 
                                            href={banco.urlPaginaOficialEntidadBancaria}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            <img className='w-[60px] h-[60px] ' src={banco.urlLogoEntidadBancaria} alt=''/>
                                        </a> */}
                                        <div className='flex-col  flex'>
                                            <span>{rmo.abrevEntidadBancaria}</span>
                                        </div>
                                        <div className='flex-col  flex'>
                                            <span>S/ {rmo.montoAcumulado}</span>
                                            {/* <span>CCI: {banco.cci}</span> */}
                                        </div>
                                    </div>                                
                                ))
                                :
                                <div>
                                    <span>No se encontraron bancos registrados</span>
                                </div>
                        }
                        
                        
                        {/* <div>
                            Total 
                        </div> */}
                    </div>
                </div>
            </div>
                </div>
            </div>
        </Modal>
    </>


)


}